import { createStandardAction } from 'typesafe-actions';

const MODAL_OPEN = 'MODAL_OPEN';
const MODAL_CLOSE = 'MODAL_CLOSE';

export const openModal = createStandardAction(MODAL_OPEN)<string>();
export const closeModal = createStandardAction(MODAL_CLOSE)<string>();



// WEBPACK FOOTER //
// ./src/modules/modal/actions.ts